module.exports = __webpack_public_path__ + "img/video-placeholder.0052cf3b.png";